import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useForm} from 'react-hook-form'
import {userLogin} from '../../redux/actions/userAction'
import {useEffect} from 'react'
import {useNavigate, useLocation, Link} from 'react-router-dom'

import 'react-toastify/dist/ReactToastify.css'
import {reset} from '../../redux/reducers/auth/forgotPasswordSlice'
import {resetFormrp} from '../../redux/reducers/auth/resetPasswordSlice'
import {useSnackbar} from 'notistack'

import {Box, Stack} from '@mui/system'

import * as Yup from 'yup'
import {yupResolver} from '@hookform/resolvers/yup'
import {FormProvider} from '../../common/hook-form'

import {apiConstants, postGeneric} from '../../common/constants'
import {
  DividerText,
  ForgotPasswordButton,
  HeaderContainer,
  IconContainer,
  StyledDivider,
  StyledIcon,
  StyledLoadingButton,
  StyledTextField,
  SubTitle,
  WelcomeTitle,
} from './StyledElements'
import {LockReset, Password} from '@mui/icons-material'
import {Grid} from '@mui/material'

export default function CreateNewPassword() {
  const dispatch = useDispatch()
  const {userInfo, error} = useSelector((state) => state.user)
  const {rpInfo} = useSelector((state) => state.resetPasswordSlice)
  const navigate = useNavigate()
  const {enqueueSnackbar} = useSnackbar()
  const {state} = useLocation()

  // const [passwordType, togglePasswordType] = useState("password");

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        oldPassword: Yup.string().required('Old password is required'),
        newPassword: Yup.string().required('New password is required'),
        confirmPassword: Yup.string()
          .oneOf([Yup.ref('newPassword'), null], "Passwords don't match")
          .required('Confirm password is required'),
      })
    ),
    defaultValues: {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    },
  })

  const {handleSubmit} = methods

  // redirect authenticated user to profile screen
  useEffect(() => {
    dispatch(reset())
    if (Object.keys(rpInfo).length !== 0) {
      enqueueSnackbar('Your password has been updated successfully.', {
        variant: 'success',
      })
      dispatch(resetFormrp())
    }
    if (Object.keys(userInfo).length !== 0) {
      navigate('/')
    }

    // eslint-disable-next-line
  }, [navigate, userInfo])

  const onSubmit = (data) => {
    const postData = {
      username: state,
      current_password: data.oldPassword,
      new_password: data.newPassword,
    }

    postGeneric(apiConstants.RESET_PASSWORD, postData)
      .then((response) => {
        // console.log("password response", response);
        if (response.status === 200) {
          const logindata = {
            username: state,
            password: data.newPassword,
          }
          enqueueSnackbar('Your password has been updated successfully.', {
            variant: 'success',
          })

          dispatch(userLogin(logindata))
        }
      })
      .catch((error) => {
        enqueueSnackbar(error?.response?.data?.message || 'Oops Something went wrong!', {
          variant: 'error',
        })
      })
  }

  if (error && error.error) {
    enqueueSnackbar(error.error, {variant: 'error'})
  }

  // const handleMouseDownPassword = (event) => {
  //   event.preventDefault();
  // };

  return (
    <Box>
      <HeaderContainer>
        <WelcomeTitle variant='h4'>Create New Password</WelcomeTitle>
        <SubTitle variant='body1' color='text.secondary'>
          Provide the required details below to reset your login password.
        </SubTitle>
      </HeaderContainer>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <StyledTextField
              variant='outlined'
              name='oldPassword'
              label='Enter old password'
              placeholder='Please enter your old password'
              InputProps={{
                startAdornment: (
                  <IconContainer>
                    <StyledIcon>
                      <Password />
                    </StyledIcon>
                  </IconContainer>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <StyledTextField
              variant='outlined'
              name='newPassword'
              label='Enter new password'
              placeholder='Please enter your new password'
              InputProps={{
                startAdornment: (
                  <IconContainer>
                    <StyledIcon>
                      <Password />
                    </StyledIcon>
                  </IconContainer>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <StyledTextField
              variant='outlined'
              name='confirmPassword'
              label='Confirm new password'
              placeholder='Please re-enter your new password'
              InputProps={{
                startAdornment: (
                  <IconContainer>
                    <StyledIcon>
                      <Password />
                    </StyledIcon>
                  </IconContainer>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Stack spacing={2}>
              <StyledLoadingButton
                startIcon={<LockReset />}
                fullWidth
                size='large'
                type='submit'
                variant='contained'
              >
                Submit
              </StyledLoadingButton>
              <StyledDivider>
                <DividerText variant='body2' color='text.secondary'>
                  OR
                </DividerText>
              </StyledDivider>
              <ForgotPasswordButton variant='text' component={Link} to='/login'>
                Back to Login
              </ForgotPasswordButton>
            </Stack>
          </Grid>
        </Grid>
      </FormProvider>
    </Box>
  )
}
